/* Pack estilo Pluffy: cards horizontais (1/2/3 pares) + badges de % +
   seletores Cor/Tamanho por par extra, dirigindo os <select> ocultos do tema
   (mantém intacta a lógica de carrinho quantityBreakVariantChange). */
(function(){
  /* ---- config vinda do editor de temas (window.paPackConfig, emitida pelo
     bloco loader no template); sem config, cai nos valores originais ---- */
  var c = window.paPackConfig || {};
  var CFG = {
    accent:     c.accent     || '#ba584b',
    accentDark: c.accentDark || '#9d473c',
    cardBorder: c.cardBorder || '#e3e3e3',
    cardBg:     c.cardBg     || '#fbfbfb',
    selBorder:  c.selBorder  || '#2b2b2b',
    selBg:      c.selBg      || '#ececec',
    hoverBorder:c.hoverBorder|| '#c4c4c4',
    pairsBg:    c.pairsBg    || '#f4f4f4',
    benefitBg:  c.benefitBg  || '#fff',
    radius:     (c.radius != null ? c.radius : 14) + 'px',
    showPct:    c.showPct !== false,
    intro:      c.intro     != null ? c.intro     : 'Escolha a cor e o tamanho de cada par 👇',
    pairLabel:  c.pairLabel != null ? c.pairLabel : 'Par',
    note:       c.note      != null ? c.note      : '*Não cumulativo com cupons de desconto.'
  };

  /* ---- CSS autossuficiente (não depende do redesign-system.css) ---- */
  function injectCSS(){
    if(document.getElementById('pa-pack-css')) return;
    var css=''
      +'.quantity-breaks-container.pa-pack{ display:grid; grid-template-columns:repeat(var(--pa-cols,3),minmax(0,1fr)); gap:12px; align-items:stretch; margin:18px 0 6px; position:relative; max-width:100%; }'
      +'.pa-pack input{ display:none !important; }'
      +'.pa-pack .quantity-breaks__title{ grid-column:1 / -1; margin:0 0 2px; font-size:1.05rem; }'
      +'.pa-pack .quantity-break{ margin:0 !important; padding:18px 10px !important; text-align:center; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:5px; min-height:96px; border-radius:'+CFG.radius+'; border:2px solid '+CFG.cardBorder+' !important; background:'+CFG.cardBg+' !important; box-shadow:none !important; transition:border-color .15s, background .15s; cursor:pointer; }'
      +'.pa-pack .quantity-break:hover{ border-color:'+CFG.hoverBorder+' !important; }'
      +'.pa-pack input:checked + .quantity-break{ border-color:'+CFG.selBorder+' !important; background:'+CFG.selBg+' !important; box-shadow:none !important; }'
      +'.pa-pack .quantity-break::before{ display:none !important; }'
      +'.pa-pack .quantity-break__content{ flex-direction:column !important; align-items:center !important; gap:2px; width:100%; }'
      +'.pa-pack .quantity-break__left,.pa-pack .quantity-break__right{ align-items:center !important; text-align:center !important; }'
      +'.pa-pack .quantity-break__label{ justify-content:center !important; font-size:1.16rem !important; font-weight:700 !important; }'
      +'.pa-pack .quantity-break__benefit{ position:absolute !important; bottom:-11px; left:50%; transform:translateX(-50%); margin:0 !important; padding:3px 12px !important; font-size:9.5px !important; font-weight:800 !important; text-transform:uppercase !important; letter-spacing:.04em !important; color:'+CFG.accent+' !important; background:'+CFG.benefitBg+' !important; border:1.5px solid '+CFG.accent+' !important; border-radius:999px !important; line-height:1.35; white-space:nowrap; z-index:2; box-shadow:0 2px 6px rgba(58,46,42,.12); }'
      +'.pa-pack .quantity-break__caption{ display:none !important; }'
      +'.pa-pack .quantity-break__price{ font-size:1.36rem !important; margin-top:2px; }'
      +'.pa-pack .quantity-break__compare-price{ font-size:.92rem !important; }'
      +'.pa-pack .quantity-break__variants{ display:none !important; }'
      +'.pa-pct{ position:absolute; top:-12px; left:50%; transform:translateX(-50%); background:'+CFG.accent+'; color:#fff; font-size:12.5px; font-weight:700; letter-spacing:.02em; padding:3px 13px; border-radius:999px; box-shadow:0 2px 7px '+CFG.accent+'55; z-index:2; white-space:nowrap; }'
      +'.pa-pairs{ background:'+CFG.pairsBg+'; border:1px solid '+CFG.cardBorder+'; border-radius:'+CFG.radius+'; padding:14px 16px; margin:14px 0; }'
      +'.pa-pairs__intro{ margin:0 0 10px; font-size:13px; line-height:1.4; color:#3a2e2a; }'
      +'.pa-pair-row{ display:flex; align-items:center; gap:8px; margin-bottom:8px; }'
      +'.pa-pair-row:last-child{ margin-bottom:0; }'
      +'.pa-pair-row__label{ font-weight:700; color:#3a2e2a; min-width:46px; font-size:13px; }'
      +'.pa-pair-select{ flex:1 1 0; min-width:0; height:38px; border:1px solid #e0cfc6; border-radius:9px; background:#fff; padding:0 10px; font-size:13px; color:#3a2e2a; font-family:inherit; }'
      +'.pa-pair-select:focus{ outline:none; border-color:'+CFG.accent+'; }'
      +'.quantity-breaks-container.pa-nocumul-moved::after{ display:none !important; content:none !important; }'
      +'.pa-nocumul{ font-size:11px; color:#8a817c; margin:4px 0 0; text-align:left; line-height:1.4; }'
      +'.pa-coupon{ display:flex; align-items:center; justify-content:space-between; gap:12px; border:1.5px dashed #e0b3a8; background:#fbeee9; border-radius:12px; padding:12px 16px; margin:14px 0; font-size:13.5px; color:#3a2e2a; }'
      +'.pa-coupon__code{ color:'+CFG.accent+'; font-weight:700; }'
      +'.pa-coupon__btn{ background:'+CFG.accent+'; color:#fff; border:none; border-radius:9px; padding:8px 16px; font-weight:600; font-size:13px; cursor:pointer; white-space:nowrap; }'
      +'.pa-coupon__btn:hover{ background:'+CFG.accentDark+'; }'
      +'@media(max-width:480px){'
      +'  .quantity-breaks-container.pa-pack{ gap:7px; }'
      +'  .pa-pack .quantity-break{ min-width:0; padding:15px 4px !important; min-height:86px; }'
      +'  .pa-pack .quantity-break__label{ font-size:.99rem !important; }'
      +'  .pa-pack .quantity-break__price{ font-size:1.14rem !important; }'
      +'  .pa-pack .quantity-break__benefit{ font-size:7.5px !important; padding:2px 8px !important; bottom:-9px !important; letter-spacing:.01em !important; }'
      +'  .pa-pack .quantity-break__compare-price{ font-size:.82rem !important; }'
      +'  .pa-pct{ font-size:10.5px; padding:2px 9px; top:-10px; }'
      +'  .pa-pair-row{ flex-wrap:wrap; }'
      +'  .pa-pair-row__label{ min-width:100%; margin-bottom:2px; }'
      +'  .pa-pair-select{ height:36px; font-size:12px; }'
      +'}';
    var st=document.createElement('style'); st.id='pa-pack-css'; st.textContent=css; document.head.appendChild(st);
  }

  function num(t){ if(!t)return 0; var m=(t.replace(/\s/g,'').match(/([\d.,]+)/)); if(!m)return 0; return parseFloat(m[1].replace(/\./g,'').replace(',','.')); }

  /* ---- badges de % em cada card ---- */
  function initBadges(){
    if(!CFG.showPct) return;
    document.querySelectorAll('.quantity-break').forEach(function(b){
      if(b.querySelector('.pa-pct')) return;
      var p=num((b.querySelector('.quantity-break__price')||{}).textContent);
      var c=num((b.querySelector('.quantity-break__compare-price')||{}).textContent);
      if(c>p && p>0){ var pct=Math.round((1-p/c)*100); if(pct>0){ var s=document.createElement('span'); s.className='pa-pct'; s.textContent='-'+pct+'%'; b.appendChild(s); } }
    });
  }

  /* ---- move o selo "Ganhe um brinde" pra ABAIXO do preço (fica dentro do label) ---- */
  function initBrinde(){
    document.querySelectorAll('.quantity-break').forEach(function(b){
      var be=b.querySelector('.quantity-break__benefit');
      if(be && be.parentNode!==b){ b.appendChild(be); }
    });
  }

  /* ---- copiar cupom (se existir alguma barra .pa-coupon) ---- */
  function initCoupon(){
    document.querySelectorAll('.pa-coupon__btn').forEach(function(btn){
      if(btn.dataset.bound)return; btn.dataset.bound='1';
      btn.addEventListener('click',function(){
        var code=btn.getAttribute('data-code')||'';
        var done=function(){ var t=btn.textContent; btn.textContent='Copiado!'; setTimeout(function(){btn.textContent=t;},1500); };
        if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(done,done); }
        else { var ta=document.createElement('textarea'); ta.value=code; document.body.appendChild(ta); ta.select(); try{document.execCommand('copy');}catch(e){} ta.remove(); done(); }
      });
    });
  }

  /* ---- pack: cards horizontais + seletores Cor/Tamanho por par ---- */
  function parseVariants(sel){
    var out=[];
    Array.prototype.forEach.call(sel.options,function(o){
      var txt=(o.textContent||'').replace(/\s+/g,' ').trim();
      var parts=txt.split('/');
      var color=(parts[0]||'').trim();
      var size=parts.slice(1).join('/').trim();
      out.push({id:o.value, color:color, size:size, avail:!o.disabled, label:txt});
    });
    return out;
  }
  function uniq(a){ var s=[],seen={}; a.forEach(function(x){ if(!seen[x]){seen[x]=1;s.push(x);} }); return s; }
  function buildSelect(cls){ var s=document.createElement('select'); s.className='pa-pair-select '+cls; return s; }
  function fill(sel,items,current){
    sel.innerHTML='';
    items.forEach(function(it){
      var o=document.createElement('option');
      o.value=it.value; o.textContent=it.label;
      if(it.disabled){ o.disabled=true; }
      if(it.value===current){ o.selected=true; }
      sel.appendChild(o);
    });
  }

  function initPack(){
    var container=document.querySelector('.quantity-breaks-container');
    if(!container) return;
    container.classList.add('pa-pack');
    // nº de cards p/ o grid
    var cards=container.querySelectorAll('.quantity-break');
    container.style.setProperty('--pa-cols', String(Math.max(2,cards.length)));

    // precisa de selects de variante por par (produto com variantes)
    var anySel=container.querySelector('.quantity-break__variant-select');
    if(!anySel){ return; } // produto sem variantes múltiplas: só cards horizontais

    if(container.dataset.paPack==='1') return; // já montado
    container.dataset.paPack='1';

    var variants=parseVariants(anySel);
    var colors=uniq(variants.map(function(v){return v.color;}));

    // painel de pares (abaixo dos cards)
    var pairs=document.createElement('div');
    pairs.className='pa-pairs';
    pairs.id='pa-pairs';
    container.parentNode.insertBefore(pairs, container.nextSibling);

    function sizesForColor(color){
      return variants.filter(function(v){return v.color===color;});
    }
    function variantFor(color,size){
      return variants.find(function(v){return v.color===color && v.size===size;});
    }
    function mainVariant(){
      var idInput=document.querySelector('product-form input[name="id"]');
      var id=idInput ? (idInput.dataset.selectedId || (idInput.value||'').split(',')[0]) : null;
      return variants.find(function(v){return v.id===id;}) || variants.find(function(v){return v.avail;}) || variants[0];
    }

    function makePairRow(label, hiddenSelect, Q, idx){
      var mv=mainVariant();
      // estado inicial do par = o que o select oculto já tem, senão a variante principal
      var cur=variants.find(function(v){return v.id===hiddenSelect.value;}) || mv;

      var row=document.createElement('div'); row.className='pa-pair-row';
      var lab=document.createElement('span'); lab.className='pa-pair-row__label'; lab.textContent=label;
      var colSel=buildSelect('pa-pair-color');
      var sizeSel=buildSelect('pa-pair-size');
      row.appendChild(lab); row.appendChild(colSel); row.appendChild(sizeSel);

      function refreshSizes(){
        var c=colSel.value;
        var list=sizesForColor(c).map(function(v){
          return {value:v.size, label:v.size + (v.avail?'':' (esgotado)'), disabled:!v.avail};
        });
        var keep = list.some(function(x){return x.value===sizeSel.value && !x.disabled;}) ? sizeSel.value
                 : (list.find(function(x){return !x.disabled;})||list[0]||{}).value;
        fill(sizeSel, list, keep);
      }
      function commit(){
        var v=variantFor(colSel.value, sizeSel.value);
        if(!v) return;
        hiddenSelect.value=v.id;
        // dispara o onchange inline do tema -> quantityBreakVariantChange(event,Q,idx)
        hiddenSelect.dispatchEvent(new Event('change',{bubbles:true}));
      }

      fill(colSel, colors.map(function(c){return {value:c,label:c};}), cur.color);
      refreshSizes();
      // garante que sizeSel comece na cur.size se válida
      if(sizesForColor(cur.color).some(function(v){return v.size===cur.size && v.avail;})) sizeSel.value=cur.size;

      colSel.addEventListener('change',function(){ refreshSizes(); commit(); });
      sizeSel.addEventListener('change', commit);
      // sincroniza estado inicial no carrinho
      commit();
      return row;
    }

    function renderPairs(){
      var checked=container.querySelector('input[name="quantity"]:checked');
      var Q = checked ? (parseInt(checked.value,10)||1) : 1;
      pairs.innerHTML='';
      if(!checked){ pairs.style.display='none'; return; }
      var label=checked.nextElementSibling;
      var hidden=label ? label.querySelectorAll('.quantity-break__variant-select') : [];
      if(Q<2 || hidden.length<2){ pairs.style.display='none'; return; }
      pairs.style.display='block';

      if(CFG.intro){
        var intro=document.createElement('p'); intro.className='pa-pairs__intro';
        intro.textContent=CFG.intro;
        pairs.appendChild(intro);
      }

      // rendezo TODOS os pares (Par 1..Q) — cada um com cor + tamanho
      for(var k=1;k<=Q;k++){
        var hs=hidden[k-1];
        if(!hs) continue;
        pairs.appendChild(makePairRow(CFG.pairLabel+' '+k, hs, Q, k));
      }
    }

    container.querySelectorAll('input[name="quantity"]').forEach(function(r){
      r.addEventListener('change', function(){ setTimeout(renderPairs,0); });
      // garante que SEMPRE haja uma opção marcada (option 1 inclusive) —
      // neutraliza o toggle "desmarcar ao clicar de novo" do tema
      r.addEventListener('click', function(){ setTimeout(function(){
        if(!container.querySelector('input[name="quantity"]:checked')){ r.checked=true; r.dispatchEvent(new Event('change',{bubbles:true})); }
      },0); });
    });

    // MANTÉM o seletor de cima visível, mas NÃO deixa ele contar no carrinho quando 2/3 pares:
    // ao mudar o seletor de cima, o tema grava um id single em input[name=id] (que seria somado);
    // re-aplico os pares → input[name=id] volta a ser "id1,id2" (inválido single, ignorado pelo Shopify),
    // valendo só os items[] dos pares.
    var vpicker=document.querySelector('variant-radios, variant-selects');
    if(vpicker){
      vpicker.addEventListener('change', function(){
        var ck=container.querySelector('input[name="quantity"]:checked');
        if(ck && (parseInt(ck.value,10)||1)>=2){ setTimeout(renderPairs,40); }
      });
    }

    // move a nota "*Não cumulativo…" pra ABAIXO do pack (era ::after encravado no grid)
    container.classList.add('pa-nocumul-moved');
    if(CFG.note && !document.querySelector('.pa-nocumul')){
      var note=document.createElement('p'); note.className='pa-nocumul';
      note.textContent=CFG.note;
      pairs.parentNode.insertBefore(note, pairs.nextSibling);
    }

    renderPairs();
  }

  function run(){ injectCSS(); initBadges(); initBrinde(); initCoupon(); initPack(); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
  setTimeout(run,800);
})();
